import HmacSHA256 from 'crypto-js/hmac-sha256'
import Hex        from 'crypto-js/enc-hex'

const API = `${process.env.REACT_APP_HTTP_API_BASE}/kb/publish`
const API_REFRESH = `${process.env.REACT_APP_HTTP_API_BASE}/kb/refresh`
const KEY = process.env.REACT_APP_PANEL_SECRET

export async function publishPanel(channelId) {
    const body = JSON.stringify({ channelId })
    const sig  = HmacSHA256(body, KEY).toString(Hex)

    const res = await fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Signature': sig },
        body
    })
    if (!res.ok) {
        const txt = await res.text()
        throw new Error(txt || 'publish failed')
    }
}

export async function refreshPanel(channelId) {
    const body = JSON.stringify({ channelId })
    const sig  = HmacSHA256(body, KEY).toString(Hex)

    const res = await fetch(API_REFRESH, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Signature': sig },
        body
    })
    if (!res.ok) {
        const txt = await res.text()
        throw new Error(txt || 'refresh failed')
    }
}